(function () {
  'use strict';
  angular.module('ocorrencia.component', [
    'AlertasModule',
    'quadroOcorrencias',
    'pascalprecht.translate',
    'ProntuarioLinkModule'
  ]);
}());
